import { getRolePermissionRef } from '@/services/permission.service'
import type { RolePermissionRecord } from '@/components/RolePermission'

export async function getRolePermission(): Promise<RolePermissionRecord[]> {
  const permissions = (await getRolePermissionRef()).data?.data

  return Array.isArray(permissions) ? permissions : []
}
